export enum ItemRecordTypeEnum {
  ASSIGNMENT = "ASSIGNMENT",
}
